const observer = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    // 追加されたノードを確認
    mutation.addedNodes.forEach((node) => {
      // <div>要素のidが"ch-plugin"で、かつ"notranslate"クラスを持っている場合
      if (node.id === 'ch-plugin' && node.classList.contains('notranslate')) {
        // style属性を削除
        node.removeAttribute('style');
      }
    });
  });
});
// 監視対象を指定
observer.observe(document.body, {
  childList: true, // 子要素の追加・削除を監視
  subtree: true     // サブツリーも監視
});